import React, { useCallback, useEffect, useState } from 'react';
import { ModalCourseDetailWrapper } from '../styled';
import ModalCommon from 'components/Input/ModalCommon';
import { Divider, Spin, Table } from 'antd';
import Button from 'components/Button';
import Select from 'components/Select';
import images from 'assets/sheets/images';
import CustomEmptyDescription from 'components/CustomEmptyDescription';
import CourseScheduleServices from 'services/CourseScheduleServices';
import { toast } from 'sonner';
import dayjs from 'dayjs';
import { clearAllFields } from 'pages/CourseSchedule';

export const listStatus = [
  {
    label: '支払い済み',
    value: 'PAYMENT_COMPLETED',
    type: ['NEW'],
  },
  {
    label: '受付済み',
    value: 'PAYMENT_COMPLETED',
    type: ['RETAKE'],
  },
  {
    label: '金額相違あり',
    value: 'AMOUNT_DISCREPANCY',
    type: ['NEW'],
  },
  {
    label: '支払い待ち',
    value: 'WAITING_FOR_PAYMENT',
    type: ['NEW'],
  },
  {
    label: '最少催行達成待ち',
    value: 'WAITING_FOR_REGISTRATION',
    type: ['NEW'],
  },
  {
    label: 'キャンセル待ち',
    value: 'CANCELLATION_WAITING_LIST',
    type: ['NEW', 'RETAKE'],
  },
  {
    label: 'キャンセル',
    value: 'ADMIN_CANCELED',
    type: ['NEW', 'RETAKE'],
  },
];

const initialState = {
  type: 'NEW',
  status: 'ALL',
  day: '',
  date: '',
};
const ModalCourseDetail = ({
  isOpen,
  onClose,
  onSuccess,
  isEdit,
  courseId,
}) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ ...initialState });
  const [setDetailCourse] = useState({});
  const [studentList, setStudentList] = useState([]);
  const [listDay, setListDay] = useState([]);

  const getCourseById = () => {
    setLoading(true);
    CourseScheduleServices.getDetail(courseId)
      .then((res) => {
        setListDay(
          res?.data?.schedule.map((item) => {
            return {
              label: dayjs(item.startTime).format('YYYY/MM/DD'),
              value: dayjs(item.startTime).format('YYYY/MM/DD'),
            };
          })
        );
        setDetailCourse({
          ...res?.data,
          notes: res.data.note,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const getListStudent = useCallback(async (body = {}) => {
    setLoading(true);
    const bodyData = {
      ...body,
      day: listDay
        .map((item, index) => {
          return {
            ...item,
            index: index + 1,
          };
        })
        .find((item) => item.value === form.date)?.index,
    };

    CourseScheduleServices.getStudentList(courseId, clearAllFields(bodyData))
      .then((res) => {
        let count = 0;
        const items = res?.data.items.map((item) => {
          if (
            item.status !== 'CANCELLATION_WAITING_LIST' &&
            item.status !== 'ADMIN_CANCELED'
          ) {
            count += 1;
            return { ...item, on: count };
          } else {
            return { ...item, on: '' };
          }
        });

        setStudentList({
          ...res?.data,
          items: items.map((item) => ({
            ...item,
          })),
        });
      })
      .catch((err) => {
        toast.error(
          err?.message || '処理に失敗しました。もう一度お試しください。'
        );
      })
      .finally(() => setLoading(false));
  });

  useEffect(() => {
    courseId && getListStudent({ type: 'NEW' });
    courseId && getCourseById();
  }, [courseId]);

  const handleSearch = () => {
    getListStudent(form);
  };

  const columns = [
    {
      title: 'No',
      dataIndex: 'key',
      key: 'no',
      width: 60,
      render: (_, record) => <div>{record.on}</div>,
    },
    {
      title: '名前',
      dataIndex: 'name',
      key: 'name',
      width: 161,
      render: (_, record) => {
        return <div>{`${record.user.name}`}</div>;
      },
    },
    {
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 187,
      render: (_, record) => <div>{record?.user?.email}</div>,
    },
    {
      title: '開催日時',
      dataIndex: 'date',
      key: 'date',
      width: 194,
      render: (_, record) => (
        <div className="flex flex-col gap-2">
          {record.schedule.map((item, index) => (
            <div
              key={index}
              className="flex h-[28px] items-center justify-start"
            >{`${item.day}日目: ${dayjs(item.startTime).format('YYYY/MM/DD')}`}</div>
          ))}
        </div>
      ),
    },
    {
      title: 'ステータス',
      dataIndex: 'status',
      key: 'status',
      width: 205,
      render: (_, record) => (
        <div
          className={`option-cell flex flex-col items-start justify-start gap-2 rounded-[4px]`}
        >
          {record.type === 'RETAKE' ? (
            record.schedule.map((s, index) => {
              return (
                s.status && (
                  <div
                    key={index}
                    style={
                      s.status === 'CANCELLATION_WAITING_LIST' ||
                      s.status === 'ADMIN_CANCELED'
                        ? {
                            color: '#FA8C16',
                            backgroundColor: '#FFF7E6',
                            width: 'max-content',
                            padding: '3px 8px',
                            borderRadius: '4px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                          }
                        : {
                            color: '#1890FF',
                            backgroundColor: '#E6F7FF',
                            width: 'max-content',
                            padding: '3px 8px',
                            borderRadius: '4px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                          }
                    }
                  >
                    {
                      listStatus.find(
                        (item) =>
                          item.type.includes(record.type) &&
                          item.value === s.status
                      )?.label
                    }
                  </div>
                )
              );
            })
          ) : (
            <div
              style={
                record.status === 'CANCELLATION_WAITING_LIST' ||
                record.status === 'ADMIN_CANCELED'
                  ? {
                      color: '#FA8C16',
                      backgroundColor: '#FFF7E6',
                      width: 'max-content',
                      padding: '3px 8px',
                      borderRadius: '4px',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }
                  : {
                      color: '#1890FF',
                      backgroundColor: '#E6F7FF',
                      width: 'max-content',
                      padding: '3px 8px',
                      borderRadius: '4px',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }
              }
            >
              {
                listStatus.find(
                  (item) =>
                    item.type.includes(record.type) &&
                    item.value === record.status
                )?.label
              }
            </div>
          )}
        </div>
      ),
    },
    {
      title: '備考',
      dataIndex: 'notes',
      key: 'notes',
      width: 245,
      render: (_, record) => {
        if (!record.notes) return null;

        const decodeEntities = (encoded) => {
          const textarea = document.createElement('textarea');
          textarea.innerHTML = encoded;
          return textarea.value;
        };

        const lines = record.notes.split(/<br\s*\/?>/i);

        const processedLines = lines.map((line) => {
          let plain = line.replace(/<[^>]+>/g, '');
          plain = decodeEntities(plain);
          return plain.length > 14 ? plain.slice(0, 14) + '…' : plain;
        });

        return (
          <div
            className="max-w-[230px]"
            title={processedLines.join('\n')}
            style={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}
            dangerouslySetInnerHTML={{ __html: processedLines.join('<br/>') }}
          />
        );
      },
    },
  ];
  useEffect(() => {
    setLoading(false);
  }, []);

  const handleAfterOpen = useCallback(() => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      modalBody.scrollTop = 0;
    }
  }, []);

  const handleChangeData = ({ label, value }) => {
    if (label === 'date') {
      setForm({
        ...form,
        [label]: value,
      });
    } else {
      setForm({
        ...form,
        [label]: value,
      });
    }
  };

  return (
    <ModalCourseDetailWrapper>
      <Spin spinning={loading}>
        <ModalCommon
          width={1100}
          heightHeader={54}
          title={isEdit ? 'コース編集' : '受講者リスト'}
          open={isOpen}
          padding={[24, 14, 24, 24]}
          onAfterOpen={handleAfterOpen}
          onCancel={() => {
            setForm(initialState);
            onClose();
          }}
          onSubmit={onSuccess}
          footer={
            <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
              <Button
                btnType="back"
                onClick={() => {
                  setForm(initialState);
                  onClose();
                }}
                fontSize={14}
                width={120}
                height={40}
              >
                閉じる
              </Button>
            </div>
          }
        >
          <div className="flex h-[40px] w-full items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <Select
                label="分類:"
                options={[
                  {
                    label: '新規受講',
                    value: 'NEW',
                  },
                  {
                    label: '再受講',
                    value: 'RETAKE',
                  },
                ]}
                value={form.type || '新規受講'}
                widthSelect={220}
                heightSelect={40}
                widthLabel={40}
                classNameSelect="w-[140px]"
                classNameSelectRow="!gap-4"
                onChange={(e) =>
                  handleChangeData({
                    label: 'type',
                    value: e.value,
                  })
                }
                iconDown={images.icon.src}
              />
              <Select
                label="ステータス:"
                options={[
                  {
                    label: '全て',
                    value: 'ALL',
                  },
                  ...listStatus.filter((item) => item.type.includes(form.type)),
                ]}
                value={form.status || 'ALL'}
                widthSelect={220}
                heightSelect={40}
                isPopup={true}
                classNameSelect="2xl:w-[150px] xl:w-[150px]"
                widthLabel={74}
                onChange={(e) =>
                  handleChangeData({
                    label: 'status',
                    value: e.value,
                  })
                }
                iconDown={images.icon.src}
              />
            </div>

            <Button
              onClick={() => handleSearch(form)}
              btnType="outline"
              width={84}
              height={40}
            >
              <p style={{ letterSpacing: '0', fontSize: 14 }}>検索</p>
            </Button>
          </div>

          <Divider className="m-0" />

          <div className="overflow-y-auto">
            <Table
              columns={columns}
              rowKey="_id"
              dataSource={studentList?.items || []}
              loading={loading}
              pagination={false}
              locale={{
                emptyText: <CustomEmptyDescription />,
              }}
            />
          </div>
        </ModalCommon>
      </Spin>
    </ModalCourseDetailWrapper>
  );
};

export default ModalCourseDetail;
